import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { UseGetSurveysByProjectIdProps } from '.';

export function useGetSurveysByProjectId({
    projectId,
    archived = false,
    sortByCreatedAtAscending = false,
}: UseGetSurveysByProjectIdProps) {
    return useQuery({
        ...queryKeys.survey.list._ctx.byProjectId({ projectId: projectId!, archived, sortByCreatedAtAscending }),
        enabled: !!projectId,
    });
}
